module.exports = __webpack_public_path__ + "7f0ed0bb6b2e9de78b808ac456be13ae.svg";